import { useDebounce } from "use-debounce";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../../singleton/axios";

export type SearchResult = {
  symbol: string;
  name: string;
  currency: string;
  exchangeFullName: string;
  exchange: string;
  marketCap?: number;
  logoBase64?: string;
};

export function useGlobalSearch(search: string, options?: { enabled?: boolean }) {
  const [debouncedSearch] = useDebounce(search, 500);
  const isEnabled = options?.enabled ?? true;

  const query = useQuery({
    queryKey: ["global_search", debouncedSearch],
    queryFn: async () => {
      if (!debouncedSearch) return [];
      const response = await api.post<SearchResult[]>("/global-search", {
        query: debouncedSearch,
      });
      return response.data;
    },
    enabled: isEnabled && !!debouncedSearch,
  });

  return {
    ...query,
    debouncedSearch,
  };
}
